import { SwitchProps } from '@procore/core-react/dist/_typedoc/Switch/Switch.types.json';
import * as React from 'react';
export default {
  SwitchProps,
  React
};